// extracted by mini-css-extract-plugin
export default {"certificateTable":"CertificateTable_certificateTable__S45rC","fullHeight":"CertificateTable_fullHeight__iTAae","halfHeight":"CertificateTable_halfHeight__mouJr"};